import { render, staticRenderFns } from "./QuoteTermItemsSection.vue?vue&type=template&id=2e10bffc&"
import script from "./QuoteTermItemsSection.vue?vue&type=script&lang=ts&"
export * from "./QuoteTermItemsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports